const primaryStyles = params => {
  return {
    textTransform: 'uppercase',
    backgroundColor: params.hovered ? '#247eaf' : '#319bd5',
    borderColor: params.hovered ? '#247eaf' : '#319bd5',
    color: 'whitesmoke',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontSize: params.large ? '14px' : '.84em',
    borderRadius: '3px',
    margin: params.centered ? '0 auto' : 'inherit',
    padding: params.large ? '15px 30px' : '',
    lineHeight: params.large ? '14px' : '',
    textDecoration: 'none'
  };
};

const secondaryStyles = params => {
  return {
    textTransform: 'uppercase',
    backgroundColor: params.hovered ? 'lightgrey' : '#F5F5F5',
    borderColor: params.hovered ? 'lightgrey' : '#d0d0d0',
    color: '#292b2c',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontSize: params.large ? '14px' : '.84em',
    borderRadius: '3px',
    margin: params.centered ? '0 auto' : 'inherit',
    padding: params.large ? '15px 30px' : '',
    lineHeight: params.large ? '14px' : '',
    textDecoration: 'none'
  };
};

export {
  primaryStyles,
  secondaryStyles
};